export default __webpack_public_path__ + "images/f279717047502fc075b9f4e76bc17082.svg";